import React from "react";
import styled from "styled-components";
import { colors } from "../../../../styles/style";
import { HeaderText } from "../../../shared/SharedStyles";
import Button from "../../../../helpers/components/Button";

interface FirstWordsEmptyStateProps {
  canAdd: boolean;
  onAdd: () => void;
  onGoBack: () => void;
}

export const FirstWordsEmptyState: React.FC<FirstWordsEmptyStateProps> = ({
  canAdd,
  onAdd,
  onGoBack,
}) => (
  <React.Fragment>
    <EmptyContent>
      <GhostBubbles aria-hidden="true">
        <GhostBubble
          $placement="left: 0; top: 30px;"
          $background={colors.whiteBackgroundColor}
          $borderColor={colors.whiteBackgroundColor}
          $radius="28px 28px 28px 8px"
          $rotate="-7deg"
        >
          <GhostText>Mama?</GhostText>
        </GhostBubble>
        <GhostBubble
          $placement="right: 0; top: 0;"
          $background={colors.softPink}
          $borderColor={colors.softPink}
          $radius="28px 28px 8px 28px"
          $rotate="6deg"
        >
          <GhostText>Dada?</GhostText>
        </GhostBubble>
        <GhostBubble
          $placement="left: 96px; bottom: 0;"
          $background={colors.white}
          $borderColor={colors.borderWhite}
          $radius="28px 28px 28px 8px"
          $rotate="-2deg"
        >
          <GhostText>Ba!</GhostText>
        </GhostBubble>
      </GhostBubbles>
      <EmptyCopy>
        <HeaderText>Waiting for the first word</HeaderText>
        <EmptyDescription>
          When it happens, write it down here: the word, the day, and just how
          it sounded.
        </EmptyDescription>
      </EmptyCopy>
    </EmptyContent>
    <EmptyButtons>
      <Button $button_type="colored" onClick={onAdd} disabled={!canAdd}>
        Add first word
      </Button>
      <Button $button_type="primary" onClick={onGoBack}>
        Go Back
      </Button>
    </EmptyButtons>
  </React.Fragment>
);

const EmptyContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 0 32px;
`;

const GhostBubbles = styled.div`
  position: relative;
  width: 290px;
  height: 200px;
`;

interface GhostBubbleProps {
  $placement: string;
  $background: string;
  $borderColor: string;
  $radius: string;
  $rotate: string;
}

const GhostBubble = styled.div<GhostBubbleProps>`
  position: absolute;
  ${(props) => props.$placement}
  padding: 8px 24px 12px;
  background-color: ${(props) => props.$background};
  border: 1px solid ${(props) => props.$borderColor};
  border-radius: ${(props) => props.$radius};
  transform: rotate(${(props) => props.$rotate});
`;

const GhostText = styled.span`
  font-family: "Clicker Script";
  font-size: 40px;
  line-height: 48px;
  color: ${colors.softBrown};
  white-space: nowrap;
`;

const EmptyCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
`;

const EmptyDescription = styled.p`
  max-width: 290px;
  color: ${colors.softBrown};
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: -0.24px;
`;

const EmptyButtons = styled.div`
  width: 100%;
  padding: 24px 40px 20px;
`;
